<template>
  <div class="container fullwidget">
    <div class="fwnav">
      <nav class="navbar navbar-light navbar-expand p-0 overflow-auto">
        <div class="navbar-collapse">
          <ul class="navbar-nav mr-auto">
            <li
              class="nav-item"
              :class="{ active: mod.id === mode }"
              v-for="(mod, i) in modes"
              :key="i"
            >
              <a
                class="nav-link px-0"
                href="#"
                @click.prevent="mode = mod.id"
                >{{ mod.name }}</a
              >
            </li>
          </ul>
        </div>
      </nav>
      <a
        href="#"
        @click.prevent="backToDashboard"
        class="turnback fwnav__close"
      >
        <iclose :widhei="25" :strwidth="1.2" />
        <span>{{ $t('messages.close') }}</span>
      </a>
    </div>
    <news v-if="mode === 'news'" />
  </div>
</template>

<script>
import News from '@/components/FullSized/News'
import iclose from '@/components/icons/closecircle'

export default {
  name: 'FullSizedWidgets',
  components: {
    news: News,
    iclose: iclose,
  },
  data() {
    return {
      mode: 'news',
    }
  },
  computed: {
    modes() {
      return [
        { id: 'news', name: this.$t('dashboard.titles.news') },
        // { id: 'notnews', name: 'НеНовости' },
      ]
    },
  },
  methods: {
    backToDashboard() {
      this.$router.push({
        path: this.$route.path,
      })
    },
  },
}
</script>

<style lang="scss">
.fullwidget {
  .fwnav {
    // border-bottom: 2px solid $primary-color2;
    box-shadow: inset 0px -2px 0px 0px #c2c2d6; //$text-color;
    position: relative;

    .fwnav__close {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);

      span {
        padding: 0 0 0 7px !important;
      }
    }
  }

  a.turnback {
    color: #9d9dbc;

    path {
      transition: stroke 0.3s;
    }

    &:hover {
      color: #4e4e5d;
    }
    &:hover path {
      stroke: #4e4e5d;
    }

    span {
      padding: 0px 10px;
      vertical-align: middle;
    }
  }

  .nav-item {
    // &:not(:first-child) {
    //   margin-left: 1rem;
    // }

    &:not(:last-child) {
      margin-right: 2rem;
    }

    > .nav-link {
      color: black;
    }

    &.active {
      border-bottom: 2px solid $primary-color2;

      > .nav-link {
        color: $primary-color2;
      }
    }
  }
}
</style>
